<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A8l3gK/tc-custom/9781504090360.jpg?1718106104208" alt="This image is the cover for the book Fatal Environment, Mythology of the American West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fatal Environment, Mythology of the American West
      </h1>
      <p class="bookDescription body article font2">
        <b>A two-time National Book Award finalist’s “ambitious and provocative” look at Custer’s Last Stand, capitalism, and the rise of the cowboys-and-Indians legend (<i>The New York Review of Books</i>).</b><br/><br/> In <i>The Fatal Environment</i>, historian Richard Slotkin demonstrates how the myth of frontier expansion and subjugation of Native Americans helped justify the course of America’s rise to wealth and power. Using Custer’s Last Stand as a metaphor for what Americans feared might happen if the frontier should be closed and the “savage” element be permitted to dominate the “civilized,” Slotkin shows the emergence by 1890 of a mythos redefined to help Americans respond to the confusion and strife of industrialization and imperial expansion.<br/><br/> “A clearly written, challenging and provocative work that should prove enormously valuable to serious students of American history.” —<i>The New York Times</i><br/><br/> “[An] arresting hypothesis.” —Henry Nash Smith, <i>American Historical Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Slotkin
      </h2>
      
      <p class="authorDescription body article"><B>Richard Slotkin</B>, widely regarded as one of America&rsquo;s leading cultural critics, is a two-time finalist for the National Book Award. In addition to his prize-winning trilogy on the myth of the frontier in America, Slotkin is the author of <I>Lost Battalions</I>, a New York Times Notable Book, and <I>A Great Disorder</I>, as well as three historical novels, including <I>The Return of Henry Starr&#8203;</I>. He is the Olin Professor of English and American Studies,&#160;Emeritus, at Wesleyan University. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?443934b3